import { DRAW_RESULT5} from "./types";

const init = {
    isLoading: false,
    data: {},
};

const draw5 = (state = init, {type, payload}) => {
    if (type === DRAW_RESULT5) {
        return {
            ...state,
            isLoading: false,
            data: payload
        };
    } else {
        return state;
    }
};

export default draw5;
